import { Switch } from '@mui/material';
import { useGlobalStore } from '../../application/store/store';

const BarCodeOnOffSwitch = () => {
    const { formRegistrationMethod, setRegistrationMethod } = useGlobalStore();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setRegistrationMethod('barcode');
        } else {
            setRegistrationMethod('manual');
        }
    };

    return (
        <div>
            Använd streckkodsskanner
            <Switch
                checked={formRegistrationMethod === 'barcode'}
                onChange={handleChange}
            />
        </div>
    );
};

export default BarCodeOnOffSwitch;
